(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-footer-popup"]) return;
  try {
    
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

function checkCookie() {
  var user = getCookie("bf-nfp");
  if (user) {
    return true;
  } else {
    return false;
  }
};

function setRegisterCookie() {
  setCookie("bf-nfp", true, 5);
};


var section = document.querySelector('.newsletter-footer-popup')
var close = document.querySelector('.newsletter-footer-popup__form-btn--2')
var success = document.querySelector('.newsletter-footer-popup__form-success')

if (window.location.href.indexOf("/pages/") == -1) {
                               
  if (success) {
   setRegisterCookie();
  } else {
    if (!checkCookie()) {
      setTimeout(function(){
        section.classList.add('newsletter-footer-popup--active');
      }, 5000);

    }

    close.addEventListener('click', function(){
      if (!checkCookie()) {
        setRegisterCookie();
      }
      section.classList.remove('newsletter-footer-popup--active');
    });                        
  }

}


  } catch(e) { console.error(e); }
})();
})();
